export default __webpack_public_path__ + "static/media/Frontal 40.098124b3.jpg";